import { useCallback } from "react";
import { TableOverviewPage } from "./TableOverviewPage";
import { useHistory } from "react-router-dom";
import { CreateBookingPathParams, Routes } from "@greeter-venue/utility/Routes";
import { useGreeterVenueApi } from "@greeter/matter";

export function TableOverviewPageApiHandler() {
  const { api } = useGreeterVenueApi();

  const history = useHistory();
  const handleCreateBooking = useCallback(() => {
    const params: CreateBookingPathParams = {
      mode: "create",
    };
    history.push(Routes.mainGroup.editBooking.route(params));
  }, [history]);

  return <TableOverviewPage api={api} onCreateBooking={handleCreateBooking} />;
}
